import { useCallback, useState } from 'react'
import { BsPlus } from 'react-icons/bs'
import { FiX } from 'react-icons/fi'

import { Modal } from '~/components/Modal'

import { CreateDiscountForm } from './CreateDiscountForm'

type Props = {
  onSuccess?: () => void
}

export const CreateDiscountModal: React.FC<Props> = ({ onSuccess }) => {
  const [showModal, setShowModal] = useState<boolean>(false)

  const handleCloseModal = useCallback(() => {
    setShowModal(false)
  }, [])

  const handleOpenModal = useCallback(() => {
    setShowModal(true)
  }, [])

  const handleSuccess = useCallback(() => {
    setShowModal(false)
    onSuccess && onSuccess()
  }, [onSuccess])

  return (
    <>
      <button
        type='button'
        className='flex items-center gap-2 text-sm text-gpa-blue-500
          hover:text-gpa-blue-600 hover:bg-slate-50 rounded-md px-3 py-1
          self-end'
        onClick={handleOpenModal}
      >
        <BsPlus size={26} />
        Criar Novo Desconto
      </button>
      <Modal visible={showModal}>
        <div className='flex flex-col'>
          <div className='flex items-center justify-between mb-4'>
            <h1 className='text-xl'>Registrar Novo Cupom de Desconto</h1>
            <button
              type='button'
              className='p-2 rounded-full hover:bg-slate-50'
              onClick={handleCloseModal}
            >
              <FiX size={26} />
            </button>
          </div>
          <CreateDiscountForm onSuccess={handleSuccess} />
        </div>
      </Modal>
    </>
  )
}
